module.exports = __webpack_public_path__ + "static/media/22.b59542b9.jpg";